// src/pages/AdminDashboard/Tasks/TaskDetails.jsx
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

import style from './EmployeeTaskFullView.module.css'
import EmployeeNavBar from "../../Navbar/EmployeeNavbar";
import BreadCrumb from "../../../../components/BreadCrumb/BreadCrumb";

export default function EmployeeTaskDetails() {
    const { taskId, employeeId } = useParams(); // get params from URL
    const [task, setTask] = useState({});
    const [error, setError] = useState("");

    const [loading, setLoading] = useState(true);
    const apiurl = process.env.REACT_APP_SERVER_URL;
    const token = localStorage.getItem("token");

    useEffect(() => {
        if (!apiurl) {
            setError("API is not working");
            return;
        }

        fetch(`${apiurl}/tasks/${taskId}`, {
            headers: {
                "Authorization": `Bearer ${token}`,
                "Content-Type": "application/json",
            }
        })
            .then((res) => res.json())
            .then((data) => {
                setTask(data.task);
                setLoading(false)
            })
            .catch((err) => {
                setError(err.message);
                setLoading(false)
            });
    }, [taskId, apiurl, token]);

    if (error) return <p className="text-danger">{error}</p>;

    return (

        <div className="container pt-2">
            <EmployeeNavBar />

            <div className=" mb-4">
                <BreadCrumb
                    link={`/employee-dashboard/${employeeId}`}
                    name="Dashboard"
                    icon={true}
                />
                <BreadCrumb
                    link={`/employee-dashboard/${employeeId}/all-tasks`}
                    name="All Tasks"
                    icon={true}
                />
                <BreadCrumb
                    link={`/employee-dashboard/${employeeId}/all-tasks/${taskId}`}
                    name={`${task.title}`}
                    icon={false}
                />

            </div>
            <div className={style.FullViewPage}>
                <table className="table table-hover table-striped">
                    {
                        loading ?
                            <>
                                <tbody>
                                    {Array.from({ length: 10 }).map((_, idx) => {
                                        return (
                                            <>
                                                <tr key={idx} >
                                                    <td className=" text-center">
                                                        <span className="w-25 placeholder placeholder-xs"></span>
                                                    </td>
                                                    <td className=" text-center">
                                                        <span className="w-25 placeholder placeholder-xs"></span>
                                                    </td>

                                                </tr>

                                            </>
                                        )
                                    })}
                                </tbody>
                            </>
                            :
                            <>
                                <thead>
                                    <tr>
                                        <th className="w-50 ps-4">Name</th>
                                        <th className=" ps-4">Details</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td className="ps-4" style={{ width: '50%' }}>Title</td>
                                        <td className="ps-4">{task.title}</td>
                                    </tr>
                                    <tr>
                                        <td className="ps-4">Status</td>
                                        <td className="ps-4">{task.status}</td>
                                    </tr>
                                    <tr>
                                        <td className="ps-4">Priority</td>
                                        <td className="ps-4">{task.priority}</td>
                                    </tr>
                                    <tr>
                                        <td className="ps-4">Assigned By</td>
                                        <td className="ps-4">{task.assignedBy}</td>
                                    </tr>
                                    <tr>
                                        <td className="ps-4">Assigned For</td>
                                        <td className="ps-4">{task.employeeId?.join(", ")}</td>
                                    </tr>
                                    <tr>
                                        <td className="ps-4">Finishing Date</td>
                                        <td className="ps-4">{task.finishingDate}</td>
                                    </tr>
                                    <tr>
                                        <td className="ps-4">Finishing Time</td>
                                        <td className="ps-4">{task.finishingTime}</td>
                                    </tr>
                                    <tr>
                                        <td className="ps-4">Preferences</td>
                                        <td className="ps-4"> {task.preferences}</td>
                                    </tr>
                                    <tr>
                                        <td className="ps-4">Description</td>
                                        <td className="ps-4">{task.description}</td>
                                    </tr>

                                </tbody>
                            </>
                    }
                </table>
            </div>
        </div >
    );
}
